import { PureAbility, RawRuleOf } from "@casl/ability";

import { components } from "@punto/api-client/schema";

import { type LoggedUser } from "@/modules/auth/types";

// Define the subjects and actions for the application
export type Subjects = components["schemas"]["Subjects"];

export type Actions = components["schemas"]["Actions"];

export type AppAbility = PureAbility<[Actions, Subjects]>;

// JSON-based ability rules - using CASL's RawRuleOf type
export type AbilityRule = RawRuleOf<AppAbility>;

// Define ability rules in JSON format based on user roles
export const getAbilityRulesFor = (user?: LoggedUser): AbilityRule[] => {
  if (!user) {
    // Guest user - no permissions
    return [];
  }

  return user.abilities as unknown as AbilityRule[];
};

// Define user permissions based on roles using JSON rules
export const defineAbilitiesFor = (user?: LoggedUser): AppAbility => {
  const rules = getAbilityRulesFor(user);

  return new PureAbility<[Actions, Subjects]>(rules);
};
